module.exports = __webpack_public_path__ + "img/bluemetering_laptop.b709b9cf.jpeg";